{
  "confirmationNumber": "Número de confirmação {number}",
  "dateTimeRange": "{date} das {startTime} às {endTime}"
}
